module.exports = __webpack_public_path__ + "media/images/boy@2x-25d95c56.png";